import LocalDatabase from "./local-database.js";

/**
 * It returns local databases names of given couchdbName.
 * @param {String} couchdbName 
 * @return {Promise} Resolved with array of local dbNames
 */
const _getLocalDbNames = async (couchdbName) => {
  let databases = await indexedDB.databases();

  if(!databases.length) {
    return [];
  }

  let localDbs = [];

  for (let database of databases) {
    let dbName = database.name;
    if (dbName.startsWith(`_pouch_${couchdbName}-`)) {
      localDbs.push(dbName);
    }
  }

  return localDbs.map(dbName => dbName.replace(`_pouch_${couchdbName}-`, ""));
};

/**
 * It returns all database names which are synced with the server of the given Couchdb.
 * @param {Couchdb} couchdb
 * @return {Promise} Resolved with array of synced dbNames.
 */
export const fetchSyncedDatabases = async (couchdb) => {
  let dbNames = await _getLocalDbNames(couchdb.name);

  if(!dbNames.length) {
    return [];
  }

  let aPromise = dbNames.map(dbName => {
    return new LocalDatabase(dbName, couchdb).isSyncedWithServer();
  });

  let syncedDbs = [];
  let values = await Promise.all(aPromise);

  for (let i = 0; i < dbNames.length; i++) {
    if(values[i]) {
      syncedDbs.push(dbNames[i]);
    }
  }

  return syncedDbs;
};

/**
 * It destroy all local databases of the given couchdb.
 * @param {String} couchdbName
 * @return {Promise}
 */
export const destroyAll = async (couchdb) => {
  let dbNames = await _getLocalDbNames(couchdb.name);
  return Promise.allSettled(dbNames.map(dbName => new LocalDatabase(dbName, couchdb).destroy()));
};